<script>
    import Button from "@smui/button";
    import Checkbox from "@smui/checkbox";
    import FormField from "@smui/form-field";
    import Select, { Option } from "@smui/select";

    import Textfield from "@smui/textfield";
    import { onMount } from "svelte";
    import { navigate } from "svelte-routing";
    import Address from "../../components/Address.svelte";

    import title from "../../components/title";
    import { getObject, setObject } from "../../session";
    import page from "../../page";
    import Link from "svelte-routing/src/Link.svelte";
    import loading from "../../components/loading";
    import snackbar from "../../components/snackbar";
    import { post } from "../../http";

    export let location;
    let isLoading = false;

    let name = "",
        phone = "";

    let province = "",
        city = "",
        district = "",
        address = "",
        code = "";

    let saveFirst = false;
    let addressName = "";

    let packageKind = "";

    $: selectDistrict(code);
    $: packageKind && page.scrollToBottom();
    $: address.length >= 10 && page.scrollToBottom();
    $: saveFirst && page.scrollToBottom();

    function selectDistrict() {
        if (district == "") return;
        const order = getObject("order");
        origin = code;
    }

    function value(val) {
        return val == "" ? "-" : val;
    }

    function next() {
        if (saveFirst) {
            if (addressName == "") {
                snackbar.open("Nama alamat tidak boleh kosong");
                page.scrollToBottom();
                return;
            }
            loading.show();
            const shipper = {
                address_name: addressName,
                customer_name: name,
                customer_phone: phone,
                province: province,
                city: city,
                district: district,
                zipcode: "-",
                latitude: "-",
                longitude: "-",
                origin_code: code,
                address: address,
            };
            post("/api/add_address", shipper)
                .then((resp) => {
                    if (resp.status == 0) {
                        snackbar.open("Alamat berhasil disimpan");
                        gotoDestination();
                    } else {
                        snackbar.open(resp.message);
                    }
                })
                .finally(() => {
                    loading.hide();
                });
        } else gotoDestination();
    }
    function gotoDestination() {
        const order = getObject("order");
        order["origin_code"] = code;
        order["shipper_name"] = value(name);
        order["shipper_phone"] = value(phone);
        order["shipper_address"] = value(address);
        order["shipper_province"] = province;
        order["shipper_city"] = city;
        order["shipper_district"] = district;
        order["shipper_zipcode"] = "-";
        setObject("order", order);
        navigate("/destination");
    }

    onMount(() => {
        sessionStorage.removeItem("orderID");
        sessionStorage.removeItem("buttons");
        title.set("Pengirim");
        loading.isLoading().subscribe((val) => (isLoading = val));
    });
</script>

<div class="content">
    <div class="caption">
        Masukkan data pengirim atau pilih dari daftar yang
        <Link to="/origin/list">tersimpan</Link>
    </div>
    <Textfield
        bind:value={name}
        variant="outlined"
        label="Nama"
        disabled={isLoading} />
    <Textfield
        bind:value={phone}
        variant="outlined"
        label="Telepon"
        disabled={isLoading} />
    <Address
        bind:province
        bind:city
        bind:district
        bind:code
        bind:address
        bind:disabled={isLoading} />
    {#if address.length >= 10}
        <FormField>
            <Checkbox bind:checked={saveFirst} disabled={isLoading} />
            <span slot="label">Simpan alamat ini</span>
        </FormField>
        {#if saveFirst}
            <Textfield
                bind:value={addressName}
                variant="outlined"
                label="Nama penyimpanan"
                input$placeholder="Contoh: Budi Rumah atau Budi Kantor"
                disabled={isLoading} />
        {/if}

        <Button
            on:click={next}
            variant="unelevated"
            class="rounded"
            disabled={isLoading}>
            Lanjutkan
        </Button>
    {/if}
</div>
